import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { Partner } from "common/types/graphql";
import { AccordionPartnersView } from "./AccordionPartners.view";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { EditPageProps } from "pages/edit/index.page";
const PartnersEdit = dynamic<PartnersProps>(() => import("./Partners.edit").then(mod => mod.PartnersEdit));
export interface PartnersProps {
  partners?: Partner[];
  explainer?: string;
  partnerLinkDescription?: string;
}
export const Partners = props => {
  "use memo";

  const $ = _c(3);
  const {
    editing
  } = usePageProps();
  const PartnersComponent = editing ? PartnersEdit : AccordionPartnersView;
  let t0;
  if ($[0] !== PartnersComponent || $[1] !== props) {
    t0 = <PartnersComponent {...props} />;
    $[0] = PartnersComponent;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};